import { IdentityVerificationSocialInAppWebViewDialog } from '~/@mid_onboarding/sms-login/IdentityVerificationSocialInAppWebViewDialog'
import { useSendSmsLoginLink } from '~/@mid_onboarding/sms-login/useSendSmsLoginLink'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { Button } from '~/shadcn/ui/button/button'
import { Spinner } from '~/shadcn/ui/spinner'

function IdentityVerificationSocialInAppWebView() {
  const {
    mutate,
    isPending,
    twoFaCodeExpiresAt,
    isDialogOpen,
    setIsDialogOpen,
  } = useSendSmsLoginLink('/get-started/identity-verification')

  return (
    <div className="flex flex-col gap-10">
      <Button variant="accent" className="md:w-fit" onClick={() => mutate()}>
        <span>Poslať SMS s odkazom</span>
        {isPending ? (
          <Spinner className="size-6" />
        ) : (
          <ArrowForwardIcon className="ml-2" />
        )}
      </Button>
      {isDialogOpen && (
        <IdentityVerificationSocialInAppWebViewDialog
          title="Overenie totožnosti v prehliadači"
          description="Pre overenie identity kliknite na odkaz v SMS od Invest in Slovakia, ktorú sme zaslali na vaše telefonné číslo."
          onClose={() => setIsDialogOpen(false)}
          expiresAt={twoFaCodeExpiresAt}
          handleResendSms={() => mutate()}
          isSendingSms={isPending}
        />
      )}
    </div>
  )
}

export { IdentityVerificationSocialInAppWebView }
